module.exports = __webpack_public_path__ + "static/media/icon-balcon-light.97820f02.svg";